import { render, staticRenderFns } from "./EmployeeMessagesDialog.vue?vue&type=template&id=a70ef068&scoped=true&lang=pug&"
import script from "./EmployeeMessagesDialog.vue?vue&type=script&lang=ts&"
export * from "./EmployeeMessagesDialog.vue?vue&type=script&lang=ts&"
import style0 from "./EmployeeMessagesDialog.vue?vue&type=style&index=0&id=a70ef068&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a70ef068",
  null
  
)

export default component.exports